<template>
    <div id="funcionario-editar">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <TituloPagina titulo="Editar Usuário" />
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <!-- <h4 class="header">Editar funcionário</h4> -->
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-pessoa @newdata="handleDataPessoa($event)" v-if="showForm" :pessoa="item.pessoa"></formulario-pessoa>
                                    <formulario-endereco id="endereco" @newdata="handleDataEndereco($event)" v-if="showForm" :endereco="item.pessoa.endereco"></formulario-endereco>
                                    <formulario-funcionario @input="handleDataFuncionario($event)" v-if="showForm" :funcionario="item" :usuario="item.pessoa.usuario"></formulario-funcionario>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <TituloPagina titulo="Editar Especialidades" />
                    <div class="col s12">
                        <div class="card-panel">
                            <div class="row">
                                <div class="col s12">
                                    <button
                                        class="btn"
                                        :style="
                                            `margin: 4px 12px; border: 2px solid ${produtoDiagnostico.cor}; ${
                                                possuiProdutoDiagnostico(produtoDiagnostico)
                                                    ? `background-color: ${produtoDiagnostico.cor}; color: #fff;`
                                                    : `background-color: #fff; color: ${produtoDiagnostico.cor};`
                                            }`
                                        "
                                        v-for="produtoDiagnostico in produtoDiagnosticos"
                                        :key="produtoDiagnostico.produto_diagnostico_id"
                                        :disabled="salvandoEspecialidade"
                                        @click="toggleEspecialidadeProduto(produtoDiagnostico)"
                                    >
                                        {{ produtoDiagnostico.nome }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import FormularioPessoa from '@/components/common/FormularioPessoa';
    import FormularioEndereco from '@/components/common/FormularioEndereco';
    import FormularioFuncionario from '@/components/usuarios/Formulario';
    import TituloPagina from '@/components/common/TituloPagina'
    import { get, put, api } from '@/helpers/api';
    import Message from '@/helpers/message';
    import { DONO, GERENTE, ESPECIALISTA, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';

    export default {
        components: {
            FormularioPessoa,
            FormularioEndereco,
            FormularioFuncionario,
            TituloPagina
        },
        data: () => ({
            showForm: false,
            salvandoEspecialidade: false,
            item: {},
            produtoDiagnosticos: [],
            pessoa: {
                pessoa_nome: '',
                pessoa_cpf: '',
                pessoa_email: '',
                pessoa_sexo: '',
                pessoa_telefone: '',
                pessoa_celular: '',
                pessoa_data_nascimento: '',
                pessoa_profissao: '',
                pessoa_estado_civil: '',
                pessoa_filhos: '',
                pessoa_observacao: '',
            },
            endereco: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            funcionario: {
                empresa_id: '',
                funcionario_cargo_id: '',
                usuario: '',
                senha: ''
            }
        }),
        methods: {
            validateForm() {
                let validForm = true;
                if (this.pessoa.pessoa_nome === '') {
                    Message.messageError('Campo Nome é obrigatório');
                    validForm = false;
                }
                if (this.pessoa.pessoa_email === '') {
                    Message.messageError('Campo Email é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.empresa_id === '') {
                    Message.messageError('Campo Empresa é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.funcionario_cargo_id === '') {
                    Message.messageError('Campo Cargo é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.usuario === '') {
                    Message.messageError('Campo Usuário é obrigatório');
                    validForm = false;
                }
                if (this.pessoa.pessoa_cpf === '') {
                    Message.messageError('Campo CPF é obrigatório');
                    validForm = false;
                }
                return validForm;
            },
            save() {
                if (! this.validateForm()) {
                    return false;
                }
                if (Auth.getCargoUsuario2() == 3 || Auth.getCargoUsuario2() == 2) {
                    this.$router.push('/sempermissao');
                    return false;
                }

                let dataNascimento = null;
                if (this.pessoa.pessoa_data_nascimento !== '') {
                    dataNascimento = moment(this.pessoa.pessoa_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let postData = {
                    pessoa_nome: this.pessoa.pessoa_nome,
                    pessoa_cpf: this.removerCaracteres(this.pessoa.pessoa_cpf),
                    pessoa_email: this.pessoa.pessoa_email,
                    pessoa_sexo: this.pessoa.pessoa_sexo,
                    pessoa_telefone: this.removerCaracteres(this.pessoa.pessoa_telefone),
                    pessoa_celular: this.removerCaracteres(this.pessoa.pessoa_celular),
                    pessoa_data_nascimento: dataNascimento,
                    pessoa_profissao: this.pessoa.pessoa_profissao,
                    pessoa_estado_civil: this.pessoa.pessoa_estado_civil,
                    pessoa_filhos: this.pessoa.pessoa_filhos,
                    pessoa_observacao: this.pessoa.pessoa_observacao,
                    endereco_cep: this.removerCaracteres(this.endereco.endereco_cep),
                    endereco_estado: this.endereco.endereco_estado,
                    endereco_cidade: this.endereco.endereco_cidade,
                    endereco_bairro: this.endereco.endereco_bairro,
                    endereco_logradouro: this.endereco.endereco_logradouro,
                    endereco_numero: this.removerCaracteres(this.endereco.endereco_numero),
                    endereco_complemento: this.endereco.endereco_complemento,
                    empresa_id: this.funcionario.empresa_id,
                    funcionario_cargo_id: this.funcionario.funcionario_cargo_id,
                    usuario: this.funcionario.usuario,
                    senha: this.funcionario.senha,

                    empresas_ids: this.funcionario.empresas_ids,
                };

                if (this.funcionario.funcionario_relacionamentos) {
                    postData.funcionario_relacionamentos = this.funcionario.funcionario_relacionamentos
                        .map(funcionarioRelacionamento => !funcionarioRelacionamento.value
                            ? funcionario.funcionario_relacionado_id
                            : funcionarioRelacionamento.value
                        );
                }

                let self = this;

                put(`funcionario/${this.item.funcionario_id}`, postData).then(function (response) {
                    Message.messageSuccess('Usuário atualizado com sucesso.');
                    self.$router.push('/usuarios');
                }).catch(function () {
                    Message.messageError('Erro ao atualizar o Usuário.');
                    // self.$router.push('/funcionarios');
                });

            },
            handleDataPessoa: function(e) {
                [
                    this.pessoa.pessoa_nome,
                    this.pessoa.pessoa_cpf,
                    this.pessoa.pessoa_email,
                    this.pessoa.pessoa_sexo,
                    this.pessoa.pessoa_telefone,
                    this.pessoa.pessoa_celular,
                    this.pessoa.pessoa_data_nascimento,
                    this.pessoa.pessoa_profissao,
                    this.pessoa.pessoa_estado_civil,
                    this.pessoa.pessoa_filhos,
                    this.pessoa.pessoa_observacao,
                ] = e;
            },
            handleDataEndereco: function(e) {
                [
                    this.endereco.endereco_cep,
                    this.endereco.endereco_estado,
                    this.endereco.endereco_cidade,
                    this.endereco.endereco_bairro,
                    this.endereco.endereco_logradouro,
                    this.endereco.endereco_numero,
                    this.endereco.endereco_complemento,
                ] = e;
            },
            handleDataFuncionario(funcionario) {
                this.funcionario = funcionario;
            },
            removerCaracteres(string) {
                if (string === '' || ! string || string === null) {
                    return '';
                }else if(typeof string == 'number'){
                    return string;
                }

                let stringReplace;
                stringReplace = string.split('(').join('');
                stringReplace = stringReplace.split(')').join('');
                stringReplace = stringReplace.split('-').join('');
                stringReplace = stringReplace.split('.').join('');
                stringReplace = stringReplace.split('_').join('');
                return stringReplace;
            },
            possuiProdutoDiagnostico(produtoDiagnostico) {
                if (!this.item || !this.item.funcionario_especialidades) return null;

                return this.item.funcionario_especialidades.some(
                    especialidade => especialidade.produto_diagnostico_id === produtoDiagnostico.produto_diagnostico_id
                );
            },
            toggleEspecialidadeProduto(produtoDiagnostico) {
                this.salvandoEspecialidade = true;

                if (this.possuiProdutoDiagnostico(produtoDiagnostico)) {
                    const especialidade = this.item.funcionario_especialidades.find(
                        especialidade => especialidade.produto_diagnostico_id === produtoDiagnostico.produto_diagnostico_id
                    );

                    api
                        .delete(`funcionario/especialidade/${especialidade.funcionario_especialidade_id}`)
                        .then(({data: {result: {data}}}) => {
                            this.atualizarEspecialidades();
                            this.salvandoEspecialidade = false;
                        })
                        .catch(() => {
                            Message.messageError('Erro ao remover especialidade.');
                            this.salvandoEspecialidade = false;
                        });
                } else {
                    const data = {
                        produto_diagnostico_id: produtoDiagnostico.produto_diagnostico_id,
                    };

                    api
                        .post(`funcionario/${this.item.funcionario_id}/especialidade`, data)
                        .then(({data: {result: {data}}}) => {
                            this.atualizarEspecialidades();
                            this.salvandoEspecialidade = false;
                        })
                        .catch(() => {
                            Message.messageError('Erro ao adicionar especialidade.');
                            this.salvandoEspecialidade = false;
                        });
                }
            },
            atualizarEspecialidades() {
            const id = this.$route.params.id;

                api.get(`funcionario/${id}`).then(({data: {result: {data}}}) => {
                    this.item.funcionario_especialidades = data.funcionario_especialidades;
                }).catch(() => {
                    Message.messageError('Erro ao atualizar especialidades.');
                })
            },
        },

        beforeRouteEnter(to, _, next) {

            const id = to.params.id;

            if (Auth.state.user.pessoa.funcionario.funcionario_id == id) {
                return next({name: 'Perfil'});
            }

            next();
        },
        created() {

            const id = this.$route.params.id;

            if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }

            api.get(`funcionario/${id}`).then(({data: {result: {data}}}) => {
                this.item = data;
                this.showForm = true;
            }).catch(() => {
                Message.messageError('Erro ao buscar funcionário.');
                this.$router.push('/usuarios');
            })

            api.get('produto-diagnostico').then(({data: {result: {data}}}) => {
                this.produtoDiagnosticos = data;
            }).catch(() => {
                Message.messageError('Erro ao buscar produtos do diagnóstico.');
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/usuarios/Editar.vue